// extracted by mini-css-extract-plugin
module.exports = {"TableContainer":"styles_TableContainer__ioOgV","TableContainer__header":"styles_TableContainer__header__3u8c3","TableContainer__body":"styles_TableContainer__body__2Jc--"};